import { createSelector } from 'reselect';

const paySelector = (state) => state.pay;

export const getPayEmbeddedData = createSelector(paySelector, (pay) => pay.embedded);
